import { FunctionComponent, useState, FormEvent } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes, { InferProps } from 'prop-types'
import { Nav, Navbar, Container, Form, FormControl, FormLabel, Row, Col, FormGroup, Card, Button } from 'react-bootstrap'

import { loginUser } from './LoginFunctions'
import { SankeyDataPropTypes }  from 'open-sankey/dist/types'


const LoginPropTypes = {
  navbar_logo: PropTypes.string.isRequired,
  navbar_logo_width: PropTypes.number,
  navbar_app_version: PropTypes.string.isRequired,
  setToken: PropTypes.func.isRequired,
  setOpenSankeyPlus: PropTypes.func.isRequired,
  setSankeySuite: PropTypes.func.isRequired,
  setSankeyDev: PropTypes.func.isRequired,
  useNavigate: PropTypes.func.isRequired,
  data: PropTypes.shape(SankeyDataPropTypes).isRequired,
  set_data:PropTypes.func.isRequired,
  set_name_user:PropTypes.func.isRequired
}
type LoginTypes = InferProps<typeof LoginPropTypes>

// Login, Register or Buy License
const Login:FunctionComponent<LoginTypes>=({
  navbar_logo, navbar_logo_width, navbar_app_version,
  setToken,
  setOpenSankeyPlus,
  setSankeySuite,
  setSankeyDev,
  useNavigate,data,set_data,
  set_name_user
})=>
{
  const [email, setUserName] = useState('')
  const [password, setPassword] = useState('')
  const [remember] = useState(false)
  const state = {
    button: ''
  }

  // Initialise traduction function
  const {t} = useTranslation()
  // Initialise navigation function
  const navigate = useNavigate()

  // Handler : Si demande d'envoi vers page de création de compte
  const handleRegister = () => {
    navigate('/license_register')
  }

  // Handler : Si demande de connection
  const handleSubmit = async (e:FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (state.button === 'login') {
      await loginUser(
        t,
        {
          email,
          password,
          remember
        },
        setToken,
        setOpenSankeyPlus,
        setSankeySuite,
        setSankeyDev,
        navigate,
        set_name_user)
    }
  }

  // React output
  return(
    <div>
      <Navbar className='bg-light navbar-Account' fixed='top' style={{ 'display': 'block' }} >
        <Container className='MenuNavigation'>
          <Navbar.Brand href="/"><img src={navbar_logo} width={navbar_logo_width ? navbar_logo_width : 200} alt="logo"/> {navbar_app_version} </Navbar.Brand>
          <Nav>
            <Nav.Item>
              <Button variant='light' onClick={()=>{navigate('/')
                set_data({...data})
              }}>{t('UserPages.to_app')}</Button>
            </Nav.Item>
          </Nav>
        </Container>
      </Navbar>

      <div className="login-wrapper">
        <Card style={{'marginTop':'175px'}}>
          <Card.Header style={{'textAlign':'center'}}>{t('Login.con_win')}</Card.Header>
          <Card.Body>
            <Form  onSubmit={handleSubmit}>
              <FormGroup as={Row} fluid='xl'>
                <Col xl={4}>
                  <FormLabel>{t('UserPages.id')}</FormLabel>
                </Col>
                <Col xl={8}>
                  <FormControl type="text" onChange={e => setUserName(e.target.value)} />
                </Col>
              </FormGroup>
              <FormGroup as={Row}>
                <Col xl={4}>
                  <FormLabel>{t('UserPages.mdp')}</FormLabel>
                </Col>
                <Col xl={8}>
                  <FormControl type="password"  onChange={e => setPassword(e.target.value)}/>
                </Col>
              </FormGroup>
              <div className='LogError' style={{'color':'red'}}></div>
              <div style={{'textAlign':'center'}}>
                <button
                  style={{'marginTop':'15px'}}
                  className='btn-login'
                  type="submit"
                  onClick={() => (state.button = 'login')}>
                    {t('Login.con')}
                </button>
              </div>
            </Form>
          </Card.Body>
        </Card>
        <button
          style={{'marginTop':'15px'}}
          className='btn-login to-register'
          type="button"
          onClick={() => handleRegister()}>
            {t('UserPages.to_reg')}
        </button>
      </div>
    </div>
  )
}

Login.propTypes = LoginPropTypes

export default Login




